import styled from "styled-components";

const ChatLayout = styled.div`
  display: grid;
  grid-template-columns: 30% 1fr;
`;

export default ChatLayout;
